module.exports = __webpack_public_path__ + "static/media/charger-pin-public.113bdab4.png";